import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let inflight = null;

export const FALLBACK_CONFIG = {
  brand: "EV-IDEX",
  legal_owner: "Wings of Change-A Layla Detox Center Limited Liability Company",
  registration: "California, United States",
  contact_email: "",
  response_time: "We typically respond within 2 business days.",
  feedback_categories: [],
};

export const usePublicConfig = () => {
  const [cfg, setCfg] = useState(cache || FALLBACK_CONFIG);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || api.get("/public/config").then((r) => { cache = r.data; return cache; }).catch(() => FALLBACK_CONFIG);
    inflight.then(setCfg);
  }, []);
  return cfg;
};

export const SITE_LINKS = {
  product: [
    { to: "/about", label: "About EV-IDEX", tid: "footer-about" },
    { to: "/transparency", label: "Transparency & track record", tid: "footer-transparency" },
    { to: "/glossary", label: "Terms explained", tid: "footer-glossary" },
    { to: "/markets", label: "Live markets", tid: "footer-markets" },
    { to: "/feed-health", label: "Market feed health", tid: "footer-feed-health" },
    { to: "/pricing", label: "Plans & pricing", nativeLabel: "Plans", tid: "footer-pricing" },
    { to: "/partners", label: "Investment Partners", tid: "footer-partners" },
    { to: "/contact", label: "Contact & Support", tid: "footer-contact" },
    { to: "/install", label: "Download the app", tid: "footer-install" },
  ],
  legal: [
    { to: "/terms", label: "Terms of Service", tid: "footer-terms" },
    { to: "/privacy", label: "Privacy Policy", tid: "footer-privacy" },
    { to: "/risk-disclosure", label: "Risk Disclosure", tid: "footer-risk" },
    { to: "/delete-account", label: "Delete Account", tid: "footer-delete" },
  ],
};

export const DISCLAIMER_SHORT = "EV-IDEX is a research and education platform. It is not a broker, exchange, bank or investment adviser, does not hold customer funds, and does not execute real trades. Nothing on EV-IDEX is financial advice or a guarantee of returns. Cryptocurrency is highly volatile — you remain solely responsible for your investment decisions.";
